module.exports = "/_next/static/images/Frame@2x-098b503d13b46213c539c54b8a09c4dd.webp";